import { Pipe, PipeTransform } from '@angular/core';
import { ActiveSubscriptionsModel, CurrentActivatedPlan } from 'src/app/models/activated-subscription.model';

@Pipe({
  name: 'getSubsTires'
})
export class GetSubscriptionTiresPipe implements PipeTransform {
  transform(activateSubsData: any, type: string = ""): any {
    let activeTiers: any = "tier0";
    let tiersList: Array<any>  = [];
    if (type) {
      tiersList = activateSubsData;
    } else {
      tiersList = activateSubsData.subscriptionTiers;
    }
    if (tiersList) {
      if (tiersList.includes('tier2')) {
        activeTiers = 'tier2';
      } else if (tiersList.includes('tier1')) {
        activeTiers = 'tier1';
      } else {
        activeTiers = 'tier0';
      }
    }
    return activeTiers;
  }
}
